<template>
  <v-dialog v-model="edit_modal" max-width="912" persistent content-class="elevation-0">
    <v-card :loading="loading" max-width="900" class="mb-5 mr-5">
      <v-card-title>{{(is_view_mode)?'Customer Details':'Edit Customer'}}</v-card-title>
      <v-card-text>
        <v-form :readonly="is_view_mode">
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-text-field
                label="First"
                dense=""
                autofocus=""
                v-model="form_data.first_name"
                :error-messages="form_error.first_name"
                :hide-details="!form_error.first_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-text-field
                label="M.I"
                dense=""
                v-model="form_data.middle_name"
                :error-messages="form_error.middle_name"
                :hide-details="!form_error.middle_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Last"
                dense=""
                v-model="form_data.last_name"
                :error-messages="form_error.last_name"
                :hide-details="!form_error.last_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Short Code"
                v-mask="'XXXXXXX'"
                class="capitalize-whole-letter"
                v-model="form_data.short_code"
                :error-messages="form_error.short_code"
                :hide-details="!form_error.short_code"
                dense=""
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.bill_to_company"
                label="Bill To Company"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                dense=""
                v-model="form_data.zip"
                :error-messages="form_error.zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :hide-details="!form_error.zip"
                v-debounce:500="fetchZipCodes"
                :loading="zip_loading"
                autocomplete="off"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense=""
                v-model="form_data.state_id"
                @change="getCity()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense=""
                v-model="form_data.city"
                class="capitalize-first-letter"
                @change="changeCity()"
                hide-details
                :search-input.sync="city_search"
                :menu-props="{closeOnContentClick:true}"
                >
                  <template v-slot:no-data v-if="city_search">
                    <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Mobile"
                dense=""
                v-model="form_data.mobile_number"
                :error-messages="form_error.mobile_number"
                :hide-details="!form_error.mobile_number"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.active"
                label="Active"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense=""
                v-model="form_data.address_line_1"
                :error-messages="form_error.address_line_1"
                :hide-details="!form_error.address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Office"
                dense=""
                v-mask="'(###)-###-####'"
                v-model="form_data.work_phone"
                :error-messages="form_error.work_phone"
                :hide-details="!form_error.work_phone"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.email_alert"
                label="Email Alert"
                color="success"
                hide-details
                class="mt-2"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense=""
                v-model="form_data.address_line_2"
                :error-messages="form_error.address_line_2"
                :hide-details="!form_error.address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Fax"
                dense=""
                v-mask="'(###)-###-####'"
                v-model="form_data.fax"
                :error-messages="form_error.fax"
                :hide-details="!form_error.fax"
              ></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col class="d-flex justify-end">
              <v-text-field
                dense
                v-model="form_data.multiplier"
                :error-messages="form_error.multiplier"
                :hide-details="!form_error.multiplier"
                label="Multiplier "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mp-1">
            <v-col cols="6">
              <v-text-field
                label="Company Name"
                dense=""
                :disabled="!form_data.bill_to_company"
                v-model="form_data.company_name"
                :error-messages="form_error.company_name"
                :hide-details="!form_error.company_name"
                loading
              >
                <template v-slot:progress>
                  <v-progress-linear
                    value="100"
                    absolute
                    height="2"
                    class="primary"
                  ></v-progress-linear>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Email"
                dense=""
                v-model="form_data.email"
                :error-messages="form_error.email"
                :hide-details="!form_error.email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-autocomplete
                :items="domain_list"
                label="Domain"
                dense=""
                prepend-icon="mdi-at"
                v-model="form_data.email_domain"
                :error-messages="form_error.email_domain"
                :hide-details="!form_error.email_domain"
                :search-input.sync="domain_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data>
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Domain Found!</span> <span @click="addDomain" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-autocomplete
                label="Zip"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_zip"
                :error-messages="form_error.comp_zip"
                :search-input.sync="comp_zip_search"
                :items="comp_zip_items"
                :hide-details="!form_error.comp_zip"
                v-debounce:500="fetchCZipCodes"
                :loading="comp_zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="comp_zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip2" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
                <template v-slot:prepend>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-simple-checkbox
                          v-model="is_same_address"
                          :disabled="is_view_mode || !form_data.bill_to_company"
                          :ripple="false"
                          @input="sameAddress()"
                        ></v-simple-checkbox>
                      </div>
                    </template>
                    <span>Same as above address</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_state_id"
                @change="getCity(true)"
                :hide-details="!form_error.comp_state_id"
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="company_cities"
                label="City"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_city"
                class="capitalize-first-letter"
                @change="changeCity2()"
                :hide-details="!form_error.comp_city"
              :search-input.sync="comp_city_search"
              :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="comp_city_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity2" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_address_line_1"
                :error-messages="form_error.comp_address_line_1"
                :hide-details="!form_error.comp_address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Total Orders
                </v-card-subtitle>
                <v-card-text class="grey text-center lighten-1 custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                :disabled="!form_data.bill_to_company"
                dense=""
                v-model="form_data.comp_address_line_2"
                :error-messages="form_error.comp_address_line_2"
                :hide-details="!form_error.comp_address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Total Estimate
                </v-card-subtitle>
                <v-card-text class="grey text-center lighten-1 custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="2">
              <v-text-field
                label="Tax-ID"
                dense=""
                v-model="form_data.tax_id"
                :error-messages="form_error.tax_id"
                :hide-details="!form_error.tax_id"
                v-mask="'##-########'"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2"></v-col>
            <v-col cols="2">
              <v-card 
              class="pa-0 ma-0"
              rounded="0"
              flat>
                <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                  Ledger Balance
                </v-card-subtitle>
                <v-card-text class="error text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                  <p class="mb-3"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-0" v-if="is_view_mode">
        <v-btn
          fab
          color="error"
          x-small
          absolute
          @click="closePopup()"
          class="custom-close-btn"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!is_view_mode" color="primary" @click="saveCustomer()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapMutations } from "vuex";
import axios from "../../plugins/axios";
export default {
  name: "CustomerEdit",
  data: () => ({
      loading: false,
      form_data: {
        bill_to_company: false,
        text_alert: false,
        email_alert: false,
        active: true,
        zip: null,
        comp_zip: null,
        mobile_number: "",
        work_phone: "",
        fax: "",
        short_code: "",
        comp_address_line_1: null,
        comp_address_line_2: null
      },
      comp_city_search: null,
      city_search: null,
      is_same_address: false,
      form_error: {},
      state_list: [],
      company_cities: [],
      cities: [],
      domain_list: [],
      zip_search: null,
      zip_loading: false,
      new_zip_id: null,
      new_zip_id2: null,
      domain_search: null,
      zip_items: [],
      comp_zip_search: null,
      comp_zip_items: [],
      comp_zip_loading: false,
    }),
  watch: {
    edit_modal: {
      handler(val) {
        if (val) {
          this.getCustomer();
        }
      },
    },
    "form_data.zip": {
      handler() {
        this.getStates(false);
      },
    },
    "form_data.comp_zip": {
      handler() {
        this.getStates(true);
      },
    },
  },
  computed: {
    ...mapState("customer", ["edit_modal","id","is_view_mode"])
  },
  methods: {
    ...mapMutations("customer", ["setData"]),
    closePopup() {
      this.setData({ key: "edit_modal", value: false });
    },
    sameAddress() {
      if(this.is_same_address) {
        this.loading = true
        this.comp_zip_items = this.zip_items
        this.company_cities = this.cities
        this.form_data.comp_zip = this.form_data.zip
        this.form_data.comp_state_id = this.form_data.state_id
        this.form_data.comp_city = this.form_data.city
        this.form_data.comp_address_line_1 = this.form_data.address_line_1
        this.form_data.comp_address_line_2 = this.form_data.address_line_2
        this.loading = false
      }
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.state_id,city_name: _self.city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.cities.push({value: data.value,text: data.text});
          _self.form_data.city = data.value
          _self.changeCity()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addCity2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.comp_state_id,city_name: _self.comp_city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.company_cities.push({value: data.value,text: data.text});
          _self.form_data.comp_city = data.value
          _self.changeCity2()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
      .post("add_domain", {domain: _self.domain_search})
      .then(function (res) {
        let data = res.data.data;
        _self.domain_list.push({value: data.domain_id,text: data.domain});
        _self.form_data.email_domain = data.domain_id
        _self.loading = false;
      })
      .catch(function (error) {
        console.log("FAILURE!!", error);
        _self.loading = false;
      });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", {zip_code: _self.zip_search})
        .then(function (res) {
          let data = res.data.data;
          _self.zip_items.push({value: data.value,text: data.text});
          _self.form_data.zip = data.value
          _self.new_zip_id = data.value
          _self.getStates(false);
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip2() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", {zip_code: _self.comp_zip_search})
        .then(function (res) {
          let data = res.data.data;
          _self.comp_zip_items.push({value: data.value,text: data.text});
          _self.form_data.comp_zip = data.value
          _self.new_zip_id2 = data.value
          _self.getStates(true);
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getCity(forCompany = false, setValue = false) {
      let _self = this;
      let city_key = forCompany
        ? this.form_data.comp_state_id
        : this.form_data.state_id;
      axios
        .get("get_city?state_id=" + city_key)
        .then((response) => {
          if (response.data.status) {
            if (forCompany) {
              _self.company_cities = response.data.data;
              if (setValue) {
                _self.form_data.comp_city = setValue;
              }
            } else {
              _self.cities = response.data.data;
              if (setValue) {
                _self.form_data.city = setValue;
              }
            }
          }
        })
        .catch(function () {});
    },
    changeCity() {
      if(this.form_data.zip == this.new_zip_id) {
        axios
          .post("zip_update",{state_id:this.form_data.state_id, zip_id:this.form_data.zip, city_id:this.form_data.city})
          .then(() => {

          })
          .catch(function () {});
      }

      this.zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.city)
      .then((response) => {
        if (response.data.status) {
          this.zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.zip_loading = false;
      });
    },
    changeCity2() {
      if(this.form_data.comp_zip == this.new_zip_id2) {
        axios
          .post("zip_update",{state_id:this.form_data.comp_state_id, zip_id:this.form_data.comp_zip, city_id:this.form_data.comp_city})
          .then(() => {

          })
          .catch(function () {});
      }

      this.comp_zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.comp_city)
      .then((response) => {
        if (response.data.status) {
          this.comp_zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.comp_zip_loading = false;
      });
    },
    saveCustomer() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("edit_customer", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
             _self.setData({ key: "edit_modal", value: false });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getCustomer() {
      this.loading = true;
      let _self = this;
      axios
        .get("get_customer?id=" + this.id)
        .then(function (res) {
          if (res.data.status) {
            let data = res.data.data;
            for (let key in data) {
              _self.form_data[key] = data[key];
            }
            if (data.zip) {
              _self.zip_items.push({ text: data.zip, value: data.zip });
            }
            if (data.comp_zip) {
              _self.comp_zip_items.push({
                text: data.comp_zip,
                value: data.comp_zip,
              });
            }
          }
          _self.loading = false;
        });
    },
    getStates(forCompany = false) {
      let _self = this;
      let zip = forCompany ? this.form_data.comp_zip : this.form_data.zip;
      axios
        .get("get_states?zip=" + zip)
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            if (forCompany) {
              _self.company_cities = response.data.selection.all_city;
              _self.form_data.comp_state_id =
                response.data.selection.selected_state;
              _self.form_data.comp_city = response.data.selection.selected_city;
            } else {
              _self.cities = response.data.selection.all_city;
              _self.form_data.state_id = response.data.selection.selected_state;
              _self.form_data.city = response.data.selection.selected_city;
            }
          }
        })
        .catch(function () {});
    },
    getEmailDomains() {
      axios.get("get_domains").then((response) => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("k");
          this.zip_loading = false;
        });
    },
    fetchCZipCodes() {
      this.comp_zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.comp_zip_search)
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            this.comp_zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("ok");
          this.comp_zip_loading = false;
        });
    }
  },
  mounted: function () {
    this.getEmailDomains();
    //this.getCustomer();
    // this.getStates(true);
    // this.getStates(false);
  },
};
</script>

<style>
</style>